import * as types from '../mutations'

// initial state
const state = {
  all: []
}

// getters
const getters = {
  allNotifications: state => state.all
}

// actions
const actions = {
  addNotification({ commit }, notification) {
    return new Promise((resolve, reject) => {
      commit(types.DATA.RECEIVE_NOTIFICATION, notification)
      resolve()
    })
  },
  removeNotification({ commit }, notification) {
    return new Promise((resolve, reject) => {
      commit(types.DATA.REMOVE_NOTIFICATION, notification)
      resolve()
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_NOTIFICATION](state, notification) {
    state.all.push(notification)
  },
  [types.DATA.REMOVE_NOTIFICATION](state, notification) {
    state.all.splice(0, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/local/notifications.js